import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useToast } from '../components/ToastProvider';
import UploadContractUploadStep from '../features/contracts/UploadContractUploadStep';
import useUploadContractExtractionJobs from '../features/contracts/useUploadContractExtractionJobs';

// Upload is now a single step: drop files → each extraction auto-creates a
// contract (flagged "needs review") with the file attached. The job stack shows
// each created contract and links straight to it; review is optional and
// happens on the contract itself, not in a blocking form here.
export default function UploadContract() {
  const [searchParams] = useSearchParams();
  const { showToast } = useToast();
  const [error, setError] = useState(null);

  const {
    dismissJob,
    dragActive,
    files,
    handleDrag,
    handleDrop,
    handleFilesSelect,
    handleUpload,
    jobs,
    removeStagedFile,
    uploadCount,
    uploading,
  } = useUploadContractExtractionJobs({
    setError,
    showToast,
  });

  return (
    <UploadContractUploadStep
      dismissJob={dismissJob}
      dragActive={dragActive}
      error={error}
      files={files}
      handleDrag={handleDrag}
      handleDrop={handleDrop}
      handleFilesSelect={handleFilesSelect}
      handleUpload={handleUpload}
      jobs={jobs}
      removeStagedFile={removeStagedFile}
      searchParams={searchParams}
      uploadCount={uploadCount}
      uploading={uploading}
    />
  );
}
